var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vpsHeader'),_vm._m(0),_c('vpsFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suspend-error-container"},[_c('h2',{staticClass:"err-head-pos"},[_vm._v("Your UserId has been suspended")]),_c('h2',[_vm._v("Please contact an Administrator at your")]),_c('h2',[_vm._v("company or contact the Verizon Care team")]),_c('h2',[_vm._v("vps-care@verizon.com")])])
}]

export { render, staticRenderFns }